(function(){
  // config
  const SHOW_MODE = 'session'; // 'session' or 'day'
  const BYPASS_PARAM = 'nostart'; // ?nostart=1 bypasses
  const KEY_SESSION = 'buycade_started_session';
  const KEY_DAY = 'buycade_started_day';

  function today(){ return new Date().toISOString().slice(0,10); }
  function shouldBypass(){
    const url = new URL(window.location.href);
    if (url.searchParams.get(BYPASS_PARAM) === '1') return true;
    // don’t show on cart/checkout as double safety
    return /\/cart|\/checkout/i.test(url.pathname);
  }
  function alreadyStarted(){
    if(SHOW_MODE === 'session'){
      return sessionStorage.getItem(KEY_SESSION) === '1';
    } else {
      return localStorage.getItem(KEY_DAY) === today();
    }
  }
  function markStarted(){
    if(SHOW_MODE === 'session'){
      sessionStorage.setItem(KEY_SESSION,'1');
    } else {
      localStorage.setItem(KEY_DAY, today());
    }
  }

  function boot(){
    const gate = document.getElementById('buycade-start-gate');
    if(!gate) return;

    // If bypass or already started, don't show
    if (shouldBypass() || alreadyStarted()){
      gate.setAttribute('hidden','');
      return;
    }

    // Reveal gate
    gate.removeAttribute('hidden');
    gate.setAttribute('aria-hidden','false');

    const token = gate.querySelector('.bc-gate__token');
    const slot  = gate.querySelector('.bc-gate__slot');
    const btnInsert = gate.querySelector('[data-insert]');
    const btnSkip   = gate.querySelector('[data-skip]');
    const linkAccess= gate.querySelector('[data-access]');

    function finish(){
      markStarted();
      gate.classList.add('bc-hide');
      setTimeout(()=> gate.setAttribute('hidden',''), 280);
    }

    // Drag & drop
    token.addEventListener('dragstart', e=>{
      e.dataTransfer.setData('text/plain', 'buycade-token');
    });
    slot.addEventListener('dragover', e=>{ e.preventDefault(); slot.classList.add('is-over'); });
    slot.addEventListener('dragleave', ()=> slot.classList.remove('is-over'));
    slot.addEventListener('drop', e=>{
      e.preventDefault();
      slot.classList.remove('is-over');
      finish();
    });

    // Keyboard accessibility: Enter on token triggers insert
    token.addEventListener('keydown', (e)=>{
      if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); finish(); }
    });

    // Buttons
    btnInsert?.addEventListener('click', finish);
    btnSkip?.addEventListener('click', finish);
    linkAccess?.addEventListener('click', (e)=>{ e.preventDefault(); finish(); });
  }

  // Don’t block first paint
  document.addEventListener('DOMContentLoaded', boot);
})();
